import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('customize');
const SUBMIT_MAN_CUSTOMIZE = define('SUBMIT_MAN_CUSTOMIZE', true);

const initialState = {

};

export default (state = initialState, action) => {
  switch (action.type) {
    default: return state;
  }
};

export const actions = {
  submitManualCustomize: (data = {}) => ({
    type: SUBMIT_MAN_CUSTOMIZE,
    promise: api.post('/customize/admin', data),
    success: 'Manual Customize has been submitted',
    error: 'Unable to submit customize'
  })
};




// WEBPACK FOOTER //
// ./src/ducks/customize.js